class PaintCalculator extends HTMLElement {
    static WIDTH_FEET_COEFFICIENT = 0.3048;
    static WIDTH_SQUARE_FEET_COEFFICIENT = 0.0931;
    constructor() {
        super();
        this.calculateButton = this.querySelector(".calculate") || null;
        this.recalcBtn = this.querySelector('.recalc-btn') || null;
        this.addToCartBtn = this.querySelector('.cart-btn') || null;
        this.variantPricesEl = this.querySelector('[data-emulsion][data-eggshell]') || null;
        this.finishAverageCoverageMeters = this.variantPricesEl?.dataset.finishAverageCoverageMeters;
        this.finishAverageCoverageFeet = this.variantPricesEl?.dataset.finishAverageCoverageFeet;
        this.productVariantImage = this.querySelector(".variant-image");
        this.switcher = this.querySelector(".paint-switcher") || null;

        this.form = this.querySelector(".calculation-form") || null;
        this.inputs = this.querySelectorAll(".input-text");
        this.radioBtns = this.querySelectorAll("input[name='finish']");
        this.wallInputs = this.querySelectorAll(".wall-input");
        this.ceilingInput = this.querySelector(".ceiling-input") || null;
        this.removeCeilingInput = this.querySelector(".remove-ceiling") || null;
        this.inputSqM = this.querySelector(".squaremetres") || null;
        this.resultTab = this.querySelector(".result-content") || null;
        this.resultWrapper = this.querySelector(".result") || null;
        this.inputWall1W = this.querySelector(".wall1w") || null;
        this.inputWall1H = this.querySelector(".wall1h") || null;
        this.inputWall2W = this.querySelector(".wall2w") || null;
        this.inputWall2H = this.querySelector(".wall2h") || null;
        this.inputWall3W = this.querySelector(".wall3w") || null;
        this.inputWall3H = this.querySelector(".wall3h") || null;
        this.inputWall4W = this.querySelector(".wall4w") || null;
        this.inputWall4H = this.querySelector(".wall4h") || null;
        this.inputCeilW = this.querySelector(".ceilW") || null;
        this.inputCeilH = this.querySelector(".ceilH") || null;

        this.addMoreWall = this.querySelector(".add-more-wall") || null;
        this.addMoreCeiling = this.querySelector(".add-more-ceiling") || null;

        this.finishError = this.querySelector(".finish-error") || null;
    
        this.sizes = this.form.getAttribute("data-sizes") || null;

        this.squareFtToM = 0.09290304;

        this.currentFinish = null;
        this.currentResult = null;
        this.totalArea = 0;
        this.totalLitres = 0;
        
        this.radioBtns.forEach((el, index) => {
            if (index === 0) {
                this.currentFinish = JSON.parse(el.value);
            }
            el.addEventListener("change", (e) => {
                this.currentFinish = JSON.parse(e.target.value);
            });
        })

        this.calculateButton.addEventListener("click", (e) => {
            const valid = this.validationFields();
            if (valid) {
                this.calculate();
                this.form.classList.toggle("hidden");
                this.resultRender();
            }
        });

        this.addToCartBtn.addEventListener("click", this.cartFetch.bind(this));

        this.inputs.forEach((item) => {
            item.addEventListener("input", (event) => {
                this.validateInputRange(event.target);
                if (event.target === this.inputSqM) {
                    this.clearValuesOnWalls();
                } 
            });
        });

        this.recalcBtn.addEventListener("click", () => {
            this.totalArea = 0;
            this.totalLitres = 0;
            this.resultTab.classList.toggle("hidden");
            this.form.classList.toggle("hidden");
            this.resultWrapper.innerHTML = "";
        });

        this.wallInputs.forEach(el => {
            const removeWallBtn = el.querySelector(".remove-wall");
            if (removeWallBtn) {
                removeWallBtn.addEventListener("click", this.removeLastWall.bind(this));
            }
        })

        this.addMoreWall.addEventListener("click", this.addOneMoreWall.bind(this));

        this.addMoreCeiling.addEventListener("click", this.addCeiling.bind(this));

        this.removeCeilingInput.addEventListener("click", this.removeCeiling.bind(this));
    }

    addOneMoreWall() {
        for (let i = 1; i < this.wallInputs.length; i++) {
            const removeWallBtn = this.wallInputs[i].querySelector('.remove-wall')
            if (this.wallInputs[i].classList.contains("hidden")) {
                this.wallInputs[i].classList.remove("hidden");
                if (removeWallBtn.classList.contains("hidden")) {
                    removeWallBtn.classList.remove("hidden");
                }
                if (i === this.wallInputs.length - 1) {
                    this.addMoreWall.classList.add("hidden");
                }
                break;
            } else {
                if (!removeWallBtn.classList.contains("hidden")) {
                    removeWallBtn.classList.add("hidden");
                }
            }
            
        }
    }

    removeLastWall() {
        for (let i = this.wallInputs.length - 1; i > 0; i--) {
            if (!this.wallInputs[i].classList.contains("hidden")) {
                this.wallInputs[i].classList.add("hidden");
                const removeWallBtn = this.wallInputs[i - 1].querySelector(".remove-wall");
                if (removeWallBtn?.classList.contains("hidden")) {
                    removeWallBtn.classList.remove("hidden");
                }
                break;
            }
        }
        if (this.querySelector(".wall-input.hidden") && this.addMoreWall.classList.contains("hidden")) {
            this.addMoreWall.classList.remove("hidden");
        }
    }

    addCeiling() {
        this.ceilingInput.classList.remove('hidden');
        this.addMoreCeiling.classList.add('hidden');
    }

    removeCeiling() {
        this.ceilingInput.classList.add('hidden');
        this.addMoreCeiling.classList.remove('hidden');
    }

    resetValidateMessages() {
        this.finishError.classList.add("hidden");
    }

    validationFields() {
        this.resetValidateMessages();

        let valid = true;

        if (this.currentFinish === null) {
            valid = false;
            this.finishError.classList.remove("hidden");
        }

        return valid;
    }

    resultRender() {
        this.resultTab.classList.toggle("hidden");
        this.resultWrapper.innerHTML = this.resultTemplate(this.currentResult);
    }

    validateInputRange(input) {
        const min = parseInt(input.min);
        const max = parseInt(input.max);
        let value = parseInt(input.value);

        if (value < min) {
            input.value = min;
        } else if (value > max) {
            input.value = max;
        }

        if (input !== this.inputCeilW && input !== this.inputCeilH && input !== this.inputSqM) {
            this.clearSquareArea();
        }
    }

    clearSquareArea() {
        if (this.inputSqM) {
            this.inputSqM.value = "";
        }
    }

    clearValuesOnWalls() {
        this.inputWall1W.value = "";
        this.inputWall1H.value = "";
        this.inputWall2W.value = "";
        this.inputWall2H.value = "";
        this.inputWall3W.value = "";
        this.inputWall3H.value = "";
        this.inputWall4W.value = "";
        this.inputWall4H.value = "";
    }

    calculateLiters(w, h, a) {
        let area, litres = 0

        if (!isNaN(w) && !isNaN(h)) {
            this.currentFinish;
            let width = w;
            let height = h;
            let ar = a;
            let areaReal = area;

            const finishAvgCoverage = parseFloat(this.currentFinish.finish_average_coverage);
            const coats = parseFloat(this.currentFinish.finish_coats); 
            const safetyMargin = parseFloat(this.currentFinish.finish_safety_margin);

            if (this.checkMeasurementUnit() === 'imperial') {
                if (width) width *= PaintCalculator.WIDTH_FEET_COEFFICIENT;
                if (height) height *= PaintCalculator.WIDTH_FEET_COEFFICIENT;
                if (ar) ar *= PaintCalculator.WIDTH_SQUARE_FEET_COEFFICIENT;
            }

            if (!ar) {
                areaReal = width * height;
            } else {
                areaReal = Number(ar);
            }

            if (!a) {
                area = w * h;
            } else {
                area = Number(a);
            }

            this.totalArea += area;
            litres = ((areaReal / finishAvgCoverage) * coats) * safetyMargin;

        }

        return litres;
    }

    checkMeasurementUnit() {
        if (this.switcher.classList.contains('imperial')) return 'imperial';
        return 'metric';
    }

    calculate() {
        let litresForSqm,
            litresForWall1,
            litresForWall2,
            litresForWall3,
            litresForWall4,
            litresForCeil,
            _totalLitres = 0;

        litresForSqm = this.calculateLiters(0, 0, this.inputSqM.value) || 0;
        litresForWall1 = this.calculateLiters(this.inputWall1W.value, this.inputWall1H.value) || 0;
        litresForWall2 = this.calculateLiters(this.inputWall2W.value, this.inputWall2H.value) || 0;
        litresForWall3 = this.calculateLiters(this.inputWall3W.value, this.inputWall3H.value) || 0;
        litresForWall4 = this.calculateLiters(this.inputWall4W.value, this.inputWall4H.value) || 0;
        litresForCeil = this.calculateLiters(this.inputCeilW.value, this.inputCeilH.value) || 0;

        _totalLitres = litresForSqm + litresForWall1 + litresForWall2 + litresForWall3 + litresForWall4 + litresForCeil;

        this.totalLitres = Math.ceil(_totalLitres);
        if (this.totalLitres - _totalLitres >= 0.5) {
            this.totalLitres -= 0.5
        }

        const paintQuantities = this.calculatePaintQuantities(this.totalLitres);

        const tinsByLitres = this.calculateTinsByLitres(paintQuantities);

        this.currentResult = {
            total: this.totalLitres,
            totalPrice: this.calculateTotalPrice(tinsByLitres),
            totalArea: Number.isInteger(this.totalArea) ? this.totalArea : Number(this.totalArea.toFixed(2)),
            paintQuantities,
            ...this.compileTinsDescr(tinsByLitres),
        };
    }

    calculateTinsByLitres(paintQuantities) {
        const arr = [];
        if (paintQuantities["5 Litre"]) arr.push({"5": paintQuantities["5 Litre"]});
        if (paintQuantities["2.5 Litre"]) arr.push({"2.5": paintQuantities["2.5 Litre"]});
        return arr
    }

    calculateTotalPrice(tinsByLitres) {
        let sum = 0;
        const finishName = this.currentFinish.finish_name.toLowerCase();
        const currentPrices = JSON.parse(this.variantPricesEl.dataset[finishName]);
        tinsByLitres.forEach(el => {
            const key = Object.keys(el)[0];
            if (currentPrices[key]) {
                sum += el[key] * currentPrices[key];
            }
        })
        return sum;
    }

    compileTinsDescr(tinsByLitres) {
        let longTinsDescr = "";
        let shortTinsDescr = "";
        if (tinsByLitres[0]) {
            const key = Object.keys(tinsByLitres[0])[0];
            longTinsDescr += `You require ${tinsByLitres[0][key]} tins of ${key}L`;
            shortTinsDescr += `${tinsByLitres[0][key]}x Tin(s) ${key}L`;
        }
        if (tinsByLitres[1]) {
            const key = Object.keys(tinsByLitres[1])[0];
            longTinsDescr += ` and ${tinsByLitres[1][key]} tins of ${key}L`;
            shortTinsDescr += ` and ${tinsByLitres[1][key]}x Tin(s) ${key}L`;
        }
        longTinsDescr += " paint";
        return { longTinsDescr, shortTinsDescr }
    }

    calculatePaintQuantities(requiredLitres) {
        const paintSizes = this.sizes.split(",").map(Number).sort((a, b) => b - a);
        let remainingLitres = requiredLitres;
        let quantities = {};
        for (let i = 0; i < paintSizes.length; i++) {
            if (!remainingLitres) break;
            const size = paintSizes[i];
            const nextSize = paintSizes[i + 1];
            if (remainingLitres / size >= 1) {
                const count = Math.floor(remainingLitres / size);
                quantities[`${size} Litre`] = count;
                remainingLitres -= count * size;
                if (nextSize && remainingLitres / nextSize >= 1) {
                    quantities[`${size} Litre`] += 1;
                    remainingLitres = 0
                }
            } else {
                if (nextSize && remainingLitres / nextSize > 1) {
                    quantities[`${size} Litre`] = quantities[`${size} Litre`] ? quantities[`${size} Litre`] + 1 : 1 ;
                    break;
                }
                if (!nextSize) {
                    quantities[`${size} Litre`] = 1;
                }
            }
        }
        return quantities;
    }

    checkVariantsAndPrepareAddToCartData() {
        const variants = document.querySelector('#product-select')?.children;
        const items = [];
        if (variants?.length) {
            for (const key of Object.keys(this.currentResult.paintQuantities)) {
                const keyDownCased = key.toLowerCase();
                for (const variant of variants) {
                    const variantTitle = variant.dataset.variantTitle?.toLowerCase();
                    if (variantTitle === keyDownCased + ' / ' + this.currentFinish.finish_name.toLowerCase()) {
                        items.push({ 
                            id: Number(variant.value), 
                            quantity: this.currentResult.paintQuantities[key]
                        });
                        break;
                    }
                }
            }
            return { items };
        }
    }

    cartFetch() {
        const formData = this.checkVariantsAndPrepareAddToCartData();

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }).then((response) => {
            getUpdatedCart();
            this.querySelector('.close-paint-calc-btn')?.click();
        }).catch((error) => {
            console.log(error);
            addToCartFail();
        });
    }

    getUpdatedCart() {
        var customEvent = new CustomEvent('close-modals', {
            bubbles: true,
            cancelable: true,
            detail: {}
        });
        window.dispatchEvent(customEvent);
        var customEvent = new CustomEvent('update-minicart', {
            bubbles: true,
            cancelable: true,
            detail: {}
        });
        window.dispatchEvent(customEvent);
    }

    addToCartFail(jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        console.error('PROBLEM ADDING TO CART!', response.description);
        var customEvent = new CustomEvent('show-msg', {
            detail: {
                open: true,
                bgcolor: 'bg-red-500',
                textcolor: 'text-white',
                content: 'Sorry, there has been an error. Please try again later.'
            }
        });
        window.dispatchEvent(customEvent);
    }

    resultTemplate(newData) {
        let prodVarImgHTML = this.productVariantImage?.outerHTML;
        if (prodVarImgHTML) {
           prodVarImgHTML = prodVarImgHTML.replace(/hidden/g, '');
        }
        const measurementUnit = this.checkMeasurementUnit() === 'imperial' ? ' feet' : 'm';

        this.addToCartBtn.textContent = 'Add to cart - ' + this.calculateButton.dataset.currencySymbol + newData.totalPrice.toFixed(2);

        return `<p class="text-sm mt-8 pr-5 leading-2xl tracking-s text-[#4C5056]">
                    Based on your room size you will require an estimated
                    <span class="underline text-[#211D21]">
                        ${newData.total} litre(s) of paint for ${newData.totalArea}${measurementUnit}² 
                    </span>
                </p><br><br>
                <p class="text-sm mb-10 pr-5 leading-2xl tracking-s text-[#4C5056]">
                    ${measurementUnit === 'm' ? this.finishAverageCoverageMeters : this.finishAverageCoverageFeet}
                </p>
                <div class="content w-full">
                    <div class="w-full h-px bg-[#ABAEB3] rounded-sm mb-7"></div>
                    <div class="flex justify-between w-full items-center mb-7">
                    ${prodVarImgHTML}
                        <div class="flex flex-col w-full gap-[10px]">
                            <p><span class="text-2xl font-alt">${newData.total} litre(s) of paint for ${newData.totalArea}${measurementUnit}²</span></p>
                            <p class="text-sm pr-5 leading-2xl tracking-s text-[#4C5056]">${newData.longTinsDescr}</p>
                        </div>
                    </div>
                    <div class="w-full h-px bg-[#ABAEB3] rounded-sm mb-7"></div>
                    <div class="flex justify-between w-full items-center mb-7">
                        <p><span>Quantity</span></p>
                        <p>${newData.shortTinsDescr}</p>
                    </div>
                    <div class="flex justify-between w-full items-center mb-7">
                        <p><span>Total</span></p>
                        <p>${this.calculateButton.dataset.currencySymbol}${newData.totalPrice.toFixed(2)}</p>
                    </div>
                </div>`
    }
}

customElements.define("paint-calculator", PaintCalculator);
